export default __webpack_public_path__ + "assets/830eaec6b27dac027f0aecf21cbc6e95.woff";